module.exports = __webpack_public_path__ + "img/DE00178.d693e71a.png";